import getEnv from '@/shared/utils/getEnv';

export default function isWebComponentGame(handle?: string): boolean {
  const wcRenderingGames = getEnv('WEB_COMPONENT_RENDERING_GAMES');
  return wcRenderingGames?.split(',').includes(handle ?? '') || false;
}
